import { LOGO_URL } from "@/lib/brand";

export default function AuthShell({ title, subtitle, children, testId }) {
  return (
    <div
      data-testid={testId}
      className="min-h-screen flex flex-col items-center justify-center px-4 py-10"
    >
      <img
        src={LOGO_URL}
        alt="KIDS MONEY"
        className="h-24 sm:h-28 w-auto object-contain mb-5"
      />
      <div
        className="chunky-card w-full max-w-md p-6 sm:p-8"
        style={{ backgroundColor: "#FFFDF6" }}
      >
        <h1 className="font-display text-3xl sm:text-4xl text-navy leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="font-display text-base text-navy/70 mt-1 mb-5">
            {subtitle}
          </p>
        )}
        <div className={subtitle ? "" : "mt-5"}>{children}</div>
      </div>
    </div>
  );
}

export const inputClass =
  "w-full font-display text-lg text-navy rounded-2xl border-4 border-navy px-4 py-3 outline-none bg-white";
export const inputShadow = { boxShadow: "0 4px 0 0 #2A2D7C" };
